import React from "react";
import classNames from "classnames";
import { ReactComponent as ArrowSort } from "../../../static/icons/arrow-sort.svg";
import { useSelector } from "react-redux";
import "./HeaderStatisticsTable.scss";

const HeaderStatisticsTable = (
  {
    sort,
    sortColumnHandler,
  }
) => {

  const { headerList } = useSelector((state) => state.statisticsTable);

  const sortTableColumn = (index) => {
    sortColumnHandler(index, sort.isAscendingSort);
  };

  const renderArrow = (index) => {
    const arrowClass = classNames(
      "dashboard-statistics-table__header__icon",
      { "dashboard-statistics-table__header__icon--active": sort.columnIndex === index },
      { "dashboard-statistics-table__header__icon--top": !sort.isAscendingSort && sort.columnIndex === index }
    );
    return <ArrowSort className={arrowClass} />;
  };

  return (
    <thead className={"dashboard-statistics-table__header"}>
    <tr>
      <th className={"dashboard-statistics-table__header__item"}>#</th>
      {headerList.map((item, index) => {
        return (
          <th key={index + item} className={classNames(
            "dashboard-statistics-table__header__item",
            { "dashboard-statistics-table__header-item__active": sort.columnIndex === index }
          )}
              onClick={() => sortTableColumn(index)}
          >
            {item}
            {renderArrow(index)}
          </th>
        );
      })}
    </tr>
    </thead>);
};

export default HeaderStatisticsTable;
